import React, { Component } from 'react';
import { connect } from 'react-redux';
import { editProfile, updateProfile } from '../../api/profile/profile';
import { setProfile } from '../../actions/profile';
import { AvatarGenerator } from 'random-avatar-generator';
import { Link } from 'react-router-dom';
import { cleanObject, hasProfileChanged, isProfileChanged, validateEmail, validateWebsite } from '../../utils/utils';
import NotLoggedInRedirection from '../Auth/NotLoggedInRedirection/NotLoggedInRedirection';
import ChangeWallet from '../Layouts/ChangeWallet/ChangeWallet';
import $ from 'jquery';
import SuccessModal from '../Layouts/Modals/SuccessModal';
import ErrorModal from '../modals/ErrorModal';
import store from '../../store';

class EditProfile extends Component {

    generator = new AvatarGenerator();

    state = {
        profile: this.props.profile,
        editProfile: {
            display_name: null,
            custom_url: null,
            twitter_username: null,
            site_or_portfolio: null
        },
        imgSrc: null,
        image: null,
        isLoading: false,
        message: null,
        isError: false,


        showSuccessModal: false,
        showErrorModal: false

    }

    componentWillReceiveProps(nextProps) {
        if (this.state.profile !== nextProps.profile) {
            this.setState({ ...this.state, profile: nextProps.profile });
        }
    }

    // componentDidMount() {
    //     if (localStorage.getItem('theme') === 'dark') {
    //         $(".modal").addClass("DarkModal");
    //     }
    // }

    componentDidMount() {
     

        const { profile } = this.state;
        if (profile) {
            this.setState({
                editProfile: {
                    display_name: profile.display_name || "",
                    custom_url: profile.custom_url || "", // mapping here
                    twitter_username: profile.twitter_username || "",
                    site_or_portfolio: profile.site_or_portfolio || ""
                }
            });
        }
    }

    componentDidUpdate(prevProps) {
        // If profile data just arrived or changed
       
        if (
            this.props.profile &&
            this.props.profile !== prevProps.profile &&
            Object.keys(this.props.profile).length > 0
        ) {
            const profile = this.props.profile;

            this.setState({
                profile: profile,
                editProfile: {
                    display_name: profile.display_name || "",
                    custom_url: profile.custom_url || "",
                    twitter_username: profile.twitter_username || "",
                    site_or_portfolio: profile.site_or_portfolio || ""
                }
            });
        }
    }

    oc = e => {
        e.preventDefault();
        this.setState({ ...this.state, isError: false, message: null, editProfile: { ...this.state.editProfile, [e.target.name]: e.target.value } });
    }

    onUploadFile = e => {
        const file = e.target.files[0];

        const reader = new FileReader();
        const url = reader.readAsDataURL(file);

        if ((file.size / 1024) / 1024 > 100) {
            document.getElementById('launch-modal-btn').click();
            return;
        }

        reader.onloadend = function (e) {
            this.setState({ ...this.state, imgSrc: reader.result, image: file })
        }.bind(this);
    }


    infoModal = () => {
        return (
            <React.Fragment>
                <button style={{ display: 'none' }} id="launch-modal-btn" type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
                    Launch demo modal
                </button>
                <div className="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">File Size</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                File size must be equal or less then 100mb.
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Ok</button>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }

    async submit() {

        try {
            const isProfileChange = hasProfileChanged(this.state.profile, this.state.editProfile)

            if (this.state.editProfile.custom_url && this.state.editProfile.custom_url !== '' && !validateWebsite(this.state.editProfile.custom_url)) {
                return this.setState({ ...this.state, isError: true, message: 'Please enter the valid Custom URL' });
            }
            if (this.state.editProfile.site_or_portfolio && this.state.editProfile.site_or_portfolio !== '' && !validateWebsite(this.state.editProfile.site_or_portfolio)) {
                return this.setState({ ...this.state, isError: true, message: 'Please enter the valid Site Portfolio URL' });
            }
            if (this.state.image === null && isProfileChange === false) {
                return this.setState({ ...this.state, isError: true, message: 'No changes found' });
            }
            this.setState({ ...this.state, isLoading: true, isError: false });
            const formData = new FormData();
            formData.append('data', JSON.stringify(this.state.editProfile));
            if (this.state.image) formData.append('img', this.state.image);

            let profile = await editProfile(formData);
            this.props.setProfile(profile.data.data);
            this.setState({ ...this.state, showSuccessModal: true, isLoading: false });
        } catch (e) {
            this.setState({ ...this.state, showErrorModal: true, isLoading: false });
        }
    }


    render() {
        const { user_name, display_name, custom_url, twitter_username, site_or_portfolio, profile_image, email, business, public_address } = this.state.profile;
       
        return (
            <main>
                <section id="CreateCollectible" className="py-5">
                    <div className="container">
                        <div className="row justify-content-center gx-3" id='zIndexMob'>
                            <div className="col-sm-12 col-md-10 col-lg-8 col-xl-8 Fsize_16">
                                <h2 className="mb-4">Edit profile</h2>
                                <p>You can set preferred display name, create your branded profile URL and manage other personal
                                    settings</p>
                                <div className="row">
                                    <div className="col-sm-8 mb-3 mb-sm-0">
                                        <div className="mb-3">
                                            <label className="form-label CeraMed d-block mb-1">Display name</label>
                                            <input type="text" onChange={this.oc} name="display_name" value={this.state.editProfile.display_name || ''} className="form-control shadow-none"
                                                placeholder="Enter your display name" />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label CeraMed d-block mb-1">Custom URL</label>
                                            <div className="input-group">
                                                <input style={{ borderColor: this.state.editProfile.custom_url && validateWebsite(this.state.editProfile.custom_url) ? '' : !this.state.editProfile.custom_url || this.state.editProfile.custom_url == '' ? '' : 'red' }} onChange={this.oc} name="custom_url" value={this.state.editProfile.custom_url || ''} type="text" className="form-control shadow-none"
                                                    placeholder="Enter your custom URL" />
                                            </div>
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label CeraMed d-block mb-1">Twitter Username</label>
                                            <div className="input-group">
                                                <input onChange={this.oc} name="twitter_username" type="text" className="form-control shadow-none" placeholder="@" value={this.state.editProfile.twitter_username || ''} />
                                                <span className="input-group-text"><a href="#">Link</a></span>
                                            </div>
                                            <p className="form-text mb-0">Link your Twitter account to gain more trust on the
                                                marketplace</p>
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label CeraMed d-block mb-1">Personal site or portfolio</label>
                                            <input style={{ borderColor: this.state.editProfile.site_or_portfolio && validateWebsite(this.state.editProfile.site_or_portfolio) ? '' : !this.state.editProfile.site_or_portfolio || this.state.editProfile.site_or_portfolio === '' ? '' : 'red' }} onChange={this.oc} type="text" name="site_or_portfolio" value={this.state.editProfile.site_or_portfolio || ''} className="form-control shadow-none" placeholder="https://" />
                                        </div>
                                        {/* <div className="mb-3">
                                            <label className="form-label CeraMed d-block mb-1">Email</label>
                                            <input style={{ borderColor: email && validateEmail(email) ? '' : email && 'red' }} onChange={this.oc} name="email" value={email || ''} type="email" className="form-control shadow-none" placeholder="Email"
                                                />
                                            <p className="form-text mb-2">Your email for marketplace notifications</p>
                                        </div> */}
                                        {/* <div className="mb-3">
                                            <label className="form-label CeraMed d-block mb-1">Change my Wallet</label>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <input onChange={this.oc} name="public_address" value={public_address || ''} type="text" className="form-control me-2 mb-0 shadow-none" placeholder="Public Address"
                                                    readOnly />
                                                <a className="btn BtnBorder flex-auto" onClick={() => {
                                                    document.getElementById('changeWalletModalBtn').click();
                                                }}>Change</a>
                                            </div>
                                            <p className="form-text mb-2">Caution! Change your wallet may cause your NFT's lost.</p>
                                        </div> */}
                                        <div className="mb-3">
                                            {
                                                business && business.status === null ? (
                                                    <React.Fragment>
                                                        <label className="form-label CeraMed d-block mb-1">Verification</label>
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <p className="form-text me-2 mb-0">Proceed with verification process to get more
                                                                visibility and gain trust on NUCOIN Marketplace. Please allow up to several
                                                                weeks for the process.</p>
                                                            <Link to="/business/verification" className="btn BtnBorder flex-auto">Get verified</Link>
                                                        </div>
                                                    </React.Fragment>
                                                ) : business && business.status === 'PENDING' ? (
                                                    <React.Fragment>
                                                        <label className="form-label CeraMed d-block mb-1">{this.props.profile.business.name}</label>
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <p className="form-text me-2 mb-0"><strong>Registration Number:</strong> {this.props.profile.business.registration_number}</p>
                                                            <button className="btn BtnBorder flex-auto text-dark" disabled>PENDING</button>
                                                        </div>
                                                    </React.Fragment>
                                                ) : business && business.status === 'APPROVED' ? (
                                                    <React.Fragment>
                                                        <label className="form-label CeraMed d-block mb-1">{this.props.profile.business.name}</label>
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <p className="form-text me-2 mb-0"><strong>Registration Number:</strong> {this.props.profile.business.registration_number}</p>
                                                            <button className="btn BtnBorder flex-auto text-success" disabled>APPROVED</button>
                                                        </div>
                                                    </React.Fragment>
                                                ) : business && business.status === 'REJECTED' ? (
                                                    <React.Fragment>
                                                        <label className="form-label CeraMed d-block mb-1">{this.props.profile.business.name}</label>
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <p className="form-text me-2 mb-0"><strong>Registration Number:</strong> {this.props.profile.business.registration_number}</p>
                                                            <Link to="/business/verification" className="btn BtnBorder flex-auto text-danger" style={{ backgroundColor: 'white' }}>Rejected, Click to request again!</Link>
                                                        </div>
                                                    </React.Fragment>
                                                ) : null
                                            }

                                        </div>
                                        {
                                            this.state.isError ? <div className="alert alert-danger Fsize_14" role="alert">
                                                {this.state.message}
                                            </div> : null
                                        }
                                        <div className="mb-3">
                                            <button
                                                style={{
                                                    opacity:
                                                        this.state.isLoading ||
                                                            (!hasProfileChanged(this.state.profile, this.state.editProfile) && this.state.image === null)
                                                            ? 0.3
                                                            : 1
                                                }}
                                                disabled={
                                                    this.state.isLoading ||
                                                    (!hasProfileChanged(this.state.profile, this.state.editProfile) &&
                                                        this.state.image === null)
                                                }
                                                onClick={this.submit.bind(this)}
                                                className="btn BtnBlack py-2 px-4"
                                            >
                                                {'Update Profile'} {this.state.isLoading && <i className="fas fa-asterisk fa-spin" />}
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="PreviewBoxSticky">
                                            {
                                                !this.state.imgSrc && <img style={{ width: '100px', height: '100px' }} src={user_name && profile_image ? `${process.env.REACT_APP_IMAGE_URL}/profile/personalImage/${this.state.profile?.profile_image}` : this.generator.generateRandomAvatar(user_name)} alt={user_name}
                                                    className="ProfileImg rounded-circle border mb-2" />
                                            }
                                            {
                                                this.state.imgSrc && <img style={{ width: '100px', height: '100px' }} src={this.state.imgSrc} alt={user_name}
                                                    className="ProfileImg rounded-circle border mb-2" />
                                            }
                                            <input id="input-file" onChange={this.onUploadFile} type="file" accept="image/png, image/gif, image/jpeg" style={{ display: 'none' }} />
                                            <label className="form-label CeraMed">We recommend an image of at least 400x400. Gifs
                                                work too.</label>
                                            <button onClick={() => {
                                                document.getElementById('input-file').click();
                                            }} type="submit" className="btn BtnBlack py-2 px-4">Choose file</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {this.infoModal()}
                <NotLoggedInRedirection />
                <ChangeWallet />
                <SuccessModal
                    show={this.state.showSuccessModal}
                    onClose={() => this.setState({ showSuccessModal: false })}
                    title="Profile Updated"
                    message="Your profile has been updated successfully."
                    primaryButtonText="Great">

                </SuccessModal>

                <ErrorModal
                    show={this.state.showErrorModal}
                    onClose={() => this.setState({ showErrorModal: false })}
                    title="Something went wrong"
                    message="We couldn't process your request. Please try again."


                />



                <ErrorModal></ErrorModal>
            </main>
        )
    }
}

const mapStateToProps = state => ({
    profile: state.Profile.profile,
    token: state.Auth.token
})

export default connect(mapStateToProps, {
    setProfile
})(EditProfile);